import React, { FC, PropsWithChildren } from "react";
import { AuthProvider } from 'react-oidc-context';


interface AuthenticationProviderProps {
}

export const AuthenticationProvider: FC<AuthenticationProviderProps & PropsWithChildren> = (props) => {

    // @ts-ignore
    const env = window.env;

    const oidcConfig = {
        authority: env.IAM_URL + '/realms/' + env.IAM_REALM,
        client_id: env.IAM_CLIENT_ID,
        redirect_uri: window.location.origin + '/'
    };

    return (
        <AuthProvider {...oidcConfig}>
            {props.children}
        </AuthProvider>
    )
};
